import {call, put, takeLatest, fork, all, delay} from 'redux-saga/effects';
import {
    POPULAR_PLACE_LIST_ACTION, POPULAR_PLACE_LIST_FAIL,
    POPULAR_PLACE_DETAIL_ACTION, POPULAR_PLACE_DETAIL_FAIL,
    POPULAR_PLACE_DETAIL_CREATE_ACTION, POPULAR_PLACE_DETAIL_UPDATE_ACTION,
} from '../constants/Types';
import * as PopularPlaceService from './../services/popularPlaceService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {notification} from 'antd'
import { omit } from 'lodash';
import {
    setListPopularPlaces as setListPopularPlacesAction,
    setPopularPlaceDetail as setPopularPlaceDetailAction,
} from './../actions/popularPlaceAction';
import {SAGA_DELAY_TIMEOUT} from '../constants/Define';

function* setListPopularPlaceSaga() {
    yield takeLatest(POPULAR_PLACE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const limit = action.filters.pageSize ? action.filters.pageSize : undefined;
        const offset = action.filters.pageIndex ? (action.filters.pageIndex - 1) * limit : undefined;
        const params = {
            ...omit(action.filters, ['pageIndex', 'pageSize']),
            limit, offset,
        }
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(PopularPlaceService.getPopularPlaces, params);
        yield put(setListPopularPlacesAction(result));
    }, handlePopularPlaceError(POPULAR_PLACE_LIST_FAIL)))
}

function* setPopularPlaceDetailSaga() {
    yield takeLatest(POPULAR_PLACE_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PopularPlaceService.getPopularPlaceDetail, action.id);
        yield put(setPopularPlaceDetailAction(result));
    }, handlePopularPlaceError(POPULAR_PLACE_DETAIL_FAIL)))
}

function* updatePopularPlaceSaga() {
    yield takeLatest(POPULAR_PLACE_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PopularPlaceService.updatePopularPlace, action.popularPlace);
        Func.sagaSuccessMessage({ action, action, message: `${i18n.t('notification.updateSuccess')}`, description: `${i18n.t('item.popularPlace.title')} "${action.popularPlace.name}"` })
        yield put(setPopularPlaceDetailAction(action.popularPlace));
    }, handlePopularPlaceError(POPULAR_PLACE_DETAIL_FAIL)))
}

function* createPopularPlaceSaga() {
    yield takeLatest(POPULAR_PLACE_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PopularPlaceService.createPopularPlace, action.popularPlace);
        Func.sagaSuccessMessage({ action, action, message: `${i18n.t('notification.createSuccess')}`, description: `${i18n.t('item.popularPlace.title')} "${action.popularPlace.name}"` })
        yield put(setPopularPlaceDetailAction(action.popularPlace));
    }, handlePopularPlaceError(POPULAR_PLACE_DETAIL_FAIL)))
}

function handlePopularPlaceError(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'popularPlace');
}

export function* popularPlaceSaga() {
    yield all([
        fork(setListPopularPlaceSaga),
        fork(setPopularPlaceDetailSaga),
        fork(updatePopularPlaceSaga),
        fork(createPopularPlaceSaga),
    ])
}
